export default __webpack_public_path__ + "static/media/pic97.8138387c.jpg";